import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`林德政，DJ (Der-Jeng) Lin，是位在軟體產品開發領域擁有豐富資歷的專業經理人。過去二十多年來，他曾在半導體製造、供應鏈管理及資訊安全等不同領域參與各種專案，近年來也致力於將過去應用敏捷開發、專案管理及使用者經驗設計的方法轉化為實用而有趣的課程。DJ 目前任職於趨勢科技，是《UX in the Jungle》桌遊教具的主設計師，也是趨勢科技企業大學自 2016 ~ 2019 連續四年的「年度最佳講師」。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      